import { RECONCILATIONS_CONFIG } from './reconciliations-config';

export const RECONCILIATIONS_ROLES = {
  reconciliationsOverview: [RECONCILATIONS_CONFIG.policyGroups.reconciliationReader, RECONCILATIONS_CONFIG.policyGroups.reconciliationWriter],
  reconciliationsDetails: [RECONCILATIONS_CONFIG.policyGroups.reconciliationReader, RECONCILATIONS_CONFIG.policyGroups.reconciliationWriter],
  reconciliationsVolumes: [RECONCILATIONS_CONFIG.policyGroups.reconciliationReader, RECONCILATIONS_CONFIG.policyGroups.reconciliationWriter],
};
